import * as Yup from "yup";

export const contactFormSchema = Yup.object().shape({
  name: Yup.string()
    .required("Field is required!")
    .trim()
    .min(3, "Field should contain at least 3 characters")
    .max(45, "Field should be no longer than 45 characters")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$/gi,
      "Field can only contain Latin letters."
    ),
  email: Yup.string().email("Please provide a valid email address").required("Field is required!"),
  message: Yup.string()
    .required("Field is required!")
    .trim()
    .min(4, "Your message should contain at least 4 characters")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-@.,?!0-9'":()#]*)$/gi,
      "Field can only contain Latin letters."
    ),
});
